<template>
  <a-modal
    v-model="visible"
    centered
    :footer="null"
    :width="1000"
    title="职务代理"
    @cancel="$emit('change', false)">
    <vxe-grid
      ref="xGrid"
      size="medium"
      border="inner"
      align="left"
      class="vtable"
      row-key
      highlight-hover-row
      :row-style="{ cursor: 'pointer' }"
      :loading="pageLoading"
      :data="tableData"
      :columns="tableColumn"
      @cell-click="cellClick">
      <template #pager>
        <br/>
        <page-to
          :change-callback="initData"
          align="right"
        />
      </template>
    </vxe-grid>
  </a-modal>
</template>
<script>
import moment from 'moment'
import PageTo from '@/components/PageTo'
import { MyProxy as getMyProxy } from '@/api/proxy'
const PROXY_TYPE_CONFIG = ['', '全权委托', '委托制单', '委托审批']

export default {
  name: 'SelectProxy',
  components: { PageTo },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set () {}
    }
  },
  data () {
    return {
      pageLoading: false,
      tableColumn: [
        {
          title: '代理对象',
          field: 'userName'
        },
        {
          title: '代理类型',
          slots: {
            default: ({ row }, h) => [
              <span>{ PROXY_TYPE_CONFIG[row.proxyType] }</span>
            ]
          }
        },
        {
          title: '代理时限',
          slots: {
            default: ({ row }, h) => [
              <span>{ moment(row.beginTime).format('YYYY-MM-DD') }</span>,
              <span> ~ </span>,
              <span>{ moment(row.endTime).format('YYYY-MM-DD') }</span>
            ]
          }
        },
        {
          title: '操作',
          width: 70,
          slots: {
            default: ({ row }, h) => [
              <a onClick={() => { this.doProxy(row) }} href="javascript:;">代理</a>
            ]
          }
        }
      ],
      tableData: []
    }
  },
  methods: {
    cellClick ({ row }) {
      this.doProxy(row)
    },
    doProxy (item) {
      this.$emit('select', item)
      this.$emit('change', false)
    },
    async initData ({ pageNo, pageSize }) {
      this.pageLoading = true
      const res = await getMyProxy({ pageNo, pageSize })
      this.pageLoading = false
      this.tableData = res.data
      return Promise.resolve(res)
    }
  }
}
</script>
<style lang="less" scoped>
</style>
